import React, { useState, useRef, useEffect } from "react";
import { Form, FormGroup, Button } from "reactstrap";

const VerificationCodeEntry = ({
  phoneNumber,
  onVerify,
  onResendCode,
  onChangeNumber,
  isLoading,
}) => {
  const isMobile = window.innerWidth < 768;
  const [code, setCode] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  useEffect(() => {
    // Focus first input on mount
    if (inputRefs[0].current) {
      inputRefs[0].current.focus();
    }
  }, []);

  const handleChange = (index, value) => {
    // Only allow digits
    if (value && !/^\d$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Move to next input if value entered
    if (value && index < 3) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Move to previous input on backspace if current is empty
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, 4);
    if (/^\d+$/.test(pastedData)) {
      const newCode = [...code];
      pastedData.split("").forEach((char, i) => {
        if (i < 4) newCode[i] = char;
      });
      setCode(newCode);
      // Focus last filled input or last input
      const lastIndex = Math.min(pastedData.length - 1, 3);
      inputRefs[lastIndex].current.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const verificationCode = code.join("");
    if (verificationCode.length === 4) {
      onVerify(verificationCode);
    }
  };

  const isCodeComplete = code.every((digit) => digit !== "");

  return (
    <>
      <h1
        className="mfa-title"
        style={{ fontSize: isMobile ? "24px" : "28px" }}
      >
        Enter verification code
      </h1>
      <p
        className="mfa-subtitle"
        style={{
          fontSize: isMobile ? "14px" : "16px",
          marginBottom: isMobile ? "20px" : "30px",
        }}
      >
        You will receive a 4 digit code on the number you provided to confirm
        your number.
      </p>

      <p
        style={{
          color: "#666",
          fontSize: isMobile ? "13px" : "14px",
          marginBottom: "20px",
        }}
      >
        Code sent to: <strong>{phoneNumber}</strong>
      </p>

      <Form onSubmit={handleSubmit} noValidate>
        <FormGroup>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: isMobile ? "10px" : "15px",
              marginBottom: "20px",
            }}
          >
            {code.map((digit, index) => (
              <input
                key={index}
                ref={inputRefs[index]}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste}
                className="form-control"
                style={{
                  width: isMobile ? "50px" : "60px",
                  height: isMobile ? "50px" : "60px",
                  fontSize: isMobile ? "24px" : "28px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
                disabled={isLoading}
              />
            ))}
          </div>
        </FormGroup>

        <Button
          type="submit"
          color="dark"
          className="continue-btn"
          block
          style={{ height: isMobile ? "45px" : "50px" }}
          disabled={!isCodeComplete || isLoading}
        >
          {isLoading ? "Verifying..." : "Verify"}
        </Button>

        <div
          style={{
            marginTop: "20px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              color: "#666",
              fontSize: isMobile ? "13px" : "14px",
              marginBottom: "10px",
            }}
          >
            Didn't receive the code?
          </p>
          <Button
            type="button"
            color="link"
            onClick={onResendCode}
            disabled={isLoading}
            style={{
              fontSize: isMobile ? "14px" : "15px",
              padding: "0",
              marginBottom: "10px",
            }}
          >
            Resend Code
          </Button>
          <br />
          <Button
            type="button"
            color="link"
            onClick={onChangeNumber}
            disabled={isLoading}
            style={{
              fontSize: isMobile ? "14px" : "15px",
              padding: "0",
              color: "#6c757d",
            }}
          >
            Change Phone Number
          </Button>
        </div>
      </Form>
    </>
  );
};

export default VerificationCodeEntry;
